import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
import { queryKeys } from "./query-keys";

type QueryHookOptions = {
  enabled?: boolean;
};

export function useMenuQuery(options: QueryHookOptions = {}) {
  return useQuery({
    queryKey: queryKeys.menu.all,
    queryFn: api.getMenu,
    enabled: options.enabled ?? true,
  });
}

export function useCategoriesQuery(options: QueryHookOptions = {}) {
  return useQuery({
    queryKey: queryKeys.categories.all,
    queryFn: api.getCategories,
    enabled: options.enabled ?? true,
  });
}

export function useOrdersQuery(status: string = "all") {
  return useQuery({
    queryKey: queryKeys.orders.list(status),
    queryFn: () => api.getOrders(status === "all" ? undefined : status),
    placeholderData: keepPreviousData,
  });
}

export function useOrderQuery(id: number, options: QueryHookOptions = {}) {
  return useQuery({
    queryKey: queryKeys.orders.detail(id),
    queryFn: () => api.getOrder(id),
    enabled: (options.enabled ?? true) && Number.isFinite(id) && id > 0,
  });
}

export function usePrefetchOrderQuery() {
  const queryClient = useQueryClient();

  return (id: number) => {
    if (!Number.isFinite(id) || id <= 0) return;

    void queryClient.prefetchQuery({
      queryKey: queryKeys.orders.detail(id),
      queryFn: () => api.getOrder(id),
      staleTime: 30_000,
    });
  };
}
